import {
  useEffect,
  useState,
  type FC,
} from "react";
import clsx from "clsx";
import type { loader as PostEditLoader } from "../../routes/posts.edit.$postId/route";
import {
  useLoaderData,
  useNavigation,
} from "@remix-run/react";
import Modal from "../Common/Modal";
import { buttonBase } from "../Common/FormStyle";
import type { CategoryItemType } from "~/database/category.model";

interface CategoryModal {
  categories: CategoryItemType[];
  setIsModalOpen: (isOpen: boolean) => void;
  setCategories: (
    categories: CategoryItemType[],
  ) => void;
}

const CategoryModal: FC<CategoryModal> = ({
  categories,
  setCategories,
  setIsModalOpen,
}) => {
  const { allCategories } =
    useLoaderData<typeof PostEditLoader>();
  const [modalCategories, setModalCategories] =
    useState<CategoryItemType[]>(categories);

  useEffect(() => {
    setModalCategories(categories);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { state } = useNavigation();

  return (
    <Modal
      title="カテゴリー設定"
      onDismiss={() => {
        setIsModalOpen(false);
      }}
    >
      <div className="modal">
        <div className={clsx("modal-content")}>
          <div
            className={clsx(
              "overflow-scroll",
              "h-400",
            )}
          >
            <div
              className={clsx(
                "flex",
                "justify-center",
              )}
            >
              <div
                className={clsx(
                  "max-w-[90%]",
                  "flex",
                  "flex-col",
                  "gap-10",
                  "py-30",
                )}
              >
                {allCategories
                  .filter((el) => !el.is_deleted)
                  .map((el) => {
                    const hasCategory =
                      modalCategories.some(
                        (cat) => {
                          return cat.id === el.id;
                        },
                      );
                    return (
                      <div
                        className={clsx(
                          "flex",
                          "items-center",
                          "gap-10",
                          "cursor-pointer",
                        )}
                        key={el.id}
                        onClick={() => {
                          console.log(
                            "hasCategory:",
                            hasCategory,
                          );
                          if (hasCategory) {
                            setModalCategories(
                              (prev) =>
                                prev.filter(
                                  (cat) =>
                                    cat.id !==
                                    el.id,
                                ),
                            );
                          } else {
                            setModalCategories(
                              (prev) => [
                                ...prev,
                                el,
                              ],
                            );
                          }
                        }}
                      >
                        <div
                          className={clsx(
                            "w-20",
                            "h-20",
                            "border",
                            "border-black",
                          )}
                        >
                          {hasCategory && (
                            <div
                              className={clsx(
                                "w-8",
                                "h-16",
                                "border-l-2",
                                "border-t-2",
                                "ml-5",
                                "-mt-2",
                                "border-black",
                                "rotate-[230deg]",
                              )}
                            ></div>
                          )}
                        </div>
                        {el.name}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <div
            className={clsx(
              "py-20",
              "text-center",
              "border-gray-100",
              "border",
            )}
          >
            <button
              onClick={() => {
                setCategories(modalCategories);
                setIsModalOpen(false);
              }}
              className={clsx(
                buttonBase({
                  loading:
                    state === "loading" ||
                    state === "submitting",
                }),
              )}
            >
              完了
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CategoryModal;
